export default __webpack_public_path__ + "separator.png";